var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _path4, _defs5, _path5, _defs6, _path6, _defs7, _path7, _defs8, _path8, _defs9, _path9, _defs10, _path10, _defs11, _polygon, _defs12, _polygon2, _defs13, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1132.6 1207",
    style: {
      enableBackground: "new 0 0 1132.6 1207"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_1_);fill:#727272;}\n\t.st1{clip-path:url(#SVGID_2_);fill:#727272;}\n\t.st2{clip-path:url(#SVGID_3_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_5_);fill:#727272;}\n\t.st5{clip-path:url(#SVGID_6_);fill:#727272;}\n\t.st6{clip-path:url(#SVGID_7_);fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_8_);fill:#727272;}\n\t.st8{clip-path:url(#SVGID_9_);fill:#FFFFFF;}\n\t.st9{clip-path:url(#SVGID_10_);fill:#FFFFFF;}\n\t.st10{clip-path:url(#SVGID_11_);fill:#B32E5D;}\n\t.st11{clip-path:url(#SVGID_12_);fill:#A02048;}\n\t.st12{clip-path:url(#SVGID_13_);fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M806.4,126c-3,7.9-4.6,16.5-4.6,24.9c0,8.1,9.1,11.9,14,5.8c6.4-8.1,16.3-9.1,23.1-15.5 c7.4-6.9,15.5-13,23.4-19.3c10.9-8.6,22.4-16.8,32.8-26.2c17.5-15.7,30.2-34.5,33-58.4c0.5-5.3,0-12.2-3-16.3 c-3.6-5.1-10.4-7.9-13.2-9.9c-26.4-0.8-42.4,12.4-57.4,28.2C830.8,63.7,818.1,94.5,806.4,126 M835.9,113.3c1-3.8,1.3-5.8,2-7.4 c6.6-13.2,12.7-26.7,19.8-39.4c8.1-14.2,19.6-25.9,34-33.3c3.8-2,9.9,0,15,0c-0.3,4.1,0.8,8.6-0.8,12.2c-2.3,6.1-5.1,11.9-8.9,17 C881.3,83.5,858.5,96.8,835.9,113.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M941.5,294.6c0.5,5.6,5.1,7.9,10.7,8.1c18.3,0.8,36.8,1.5,51.8,2c15.5-3.8,27.7-6.1,39.4-9.9 c12.2-3.8,19.6-14,26.7-24.1c6.1-8.9,3-20.8-4.1-29.5c-8.4-10.2-19.1-8.9-29.2-7.6c-22.9,3-44.5,9.7-63.5,23.6 c-2.8,2-5.8,3.3-8.9,5.3C958.1,266.4,941,289.5,941.5,294.6 M974.1,280.4c1.5-1.8,2-2.3,2.5-2.8c14-12.2,30.5-19.6,48-23.9 c7.1-1.8,15.2-1,22.9,0c7.4,1,9.1,6.9,3.8,11.9c-3.3,3.3-7.1,7.1-11.4,7.9c-14.2,3-28.4,5.1-42.7,6.9 C990.1,281.4,982.7,280.7,974.1,280.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_31_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M851.6,70.6c10.2-17.8,24.6-32.5,42.9-41.9c4.8-2.5,12.4,0,18.8,0c-0.3,5.1,0.8,10.7-0.8,15.5 c-2.8,7.6-6.4,15-11.2,21.6c-20.1,26.7-48.5,43.2-77.2,63.8c1.3-4.8,1.5-7.4,2.5-9.4C834.9,103.6,842.5,86.6,851.6,70.6"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_33_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1021.3,253.5c9.7-2.3,20.8-1.3,31,0c9.9,1.3,12.2,9.1,5.3,16.3c-4.3,4.6-9.7,9.7-15.5,10.9 c-19.1,4.1-38.6,6.9-57.9,9.1c-9.9,1.3-19.8,0-31.5-0.3c2-2.3,2.5-3.3,3.3-3.8C974.8,269.2,997.2,259.3,1021.3,253.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M169.4,425.2c6.9-2,14-5.8,19.8-10.7c5.6-4.6,3.8-14.5-3-14.7c-8.9-0.5-14.5-7.9-22.6-9.7 c-8.6-2-16.8-5.1-25.1-7.9c-11.7-3.8-23.1-8.4-34.8-11.4c-19.8-5.1-39.4-4.6-57.4,7.1c-4.1,2.5-8.6,7.1-9.9,11.9 c-1.8,5.8-0.3,13-0.3,16.5c12.7,22.1,30,27.2,48.5,30.2C113.7,441.4,141.7,433.6,169.4,425.2 M145.7,408.4 c-3.3,1.5-4.6,2.3-6.1,2.8c-12.4,2.3-24.9,5.3-37.6,6.6c-14,1.8-27.9-1-40.4-8.4c-3.3-2-5.1-8.1-7.4-12.2c3-2.3,5.6-5.6,8.9-6.6 c5.3-1.8,10.9-2.8,16.5-2.8C102.3,388.6,122.9,399.5,145.7,408.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M319.7,261.1c4.8-3,4.8-8.1,2.5-13.2c-7.9-16.8-15.5-33.5-21.8-47.2c-10.4-11.9-18-21.8-26.7-30.5 c-8.9-9.1-21.6-11.2-33.5-12.7c-10.7-1.5-19.8,6.9-24.4,17c-5.3,11.9,0.8,21.1,6.6,29.7c13,19.1,29,35.3,50,45.7 c3,1.5,5.8,3.8,8.6,5.6C287,259.1,315.4,263.9,319.7,261.1 M292.3,238.5c-2-0.5-3-0.8-3.8-1c-17.3-6.9-31.2-18.3-43.2-32 c-4.8-5.6-7.9-13.2-10.4-20.3c-2.5-7.1,1.8-11.2,8.9-8.9c4.3,1.3,9.7,3,12.2,6.4c9.1,11.2,17.5,22.9,25.7,35.1 C285.7,223.8,288.5,230.9,292.3,238.5"
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_39_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M108.1,420.4c-17.5,2-35.1-1.3-50.8-10.4c-4.3-2.5-6.4-10.2-9.4-15.2c3.8-2.8,7.1-6.9,11.2-8.1 c6.6-2,13.7-3.6,20.6-3.3c28.7,0.8,54.6,14.5,83.3,25.7c-4.1,1.8-5.8,3-7.9,3.3C139.6,415,123.9,418.6,108.1,420.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M523.7,186.2c3.6,7.6,8.4,15,14.2,20.8c5.6,5.6,15,1.8,14-5.8c-1.3-10.2,4.8-18,5.3-27.4 c0.5-10.2,1.8-20.1,2.8-30.2c1.5-14,3.8-27.7,4.6-41.7c1.3-23.4-3-45.7-18-64.5c-3.3-4.3-8.6-8.6-13.7-9.4c-6.1-1-13,1.8-16.5,2.3 c-19.3,18.3-21.1,38.9-20.6,60.7C496.8,125.2,509.7,155.9,523.7,186.2 M535.4,156.4c-2-3.6-3.3-5.1-3.8-6.6 c-4.8-14-9.9-27.7-14-41.9c-4.3-15.7-4.3-32,0.5-47.8c1.3-4.3,6.9-7.1,10.7-10.4c2.8,3,6.6,5.6,8.1,9.1c2.8,5.8,4.8,12.2,5.8,18.3 C546.6,103.4,540,128.8,535.4,156.4"
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M516.3,115.3c-5.3-19.8-5.6-40.4,0.5-59.9c1.5-5.3,8.6-8.9,13.2-13.2c3.6,3.8,8.1,7.1,10.4,11.4 c3.3,7.4,6.1,15.2,7.4,23.1c4.8,33-3.8,65-9.4,99.8c-2.5-4.3-4.1-6.4-4.8-8.4C527.8,150.4,521.2,133.1,516.3,115.3"
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M246.8,208.8c-6.6-7.6-10.7-17.8-14-27.4c-3.3-9.4,2.5-15,12.2-12.2c5.8,1.8,13,4.3,16.8,8.9 c12.2,15.2,23.9,31.2,34.5,47.5c5.6,8.1,9.1,17.8,14.2,28.2c-3-0.8-4.1-0.8-5.1-1.3C281.9,243.1,262.8,227.6,246.8,208.8"
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "304.8,410.2 300.4,988.3 576.8,1203.5 576.8,916.4 859.5,842.8 859.5,266.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_49_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_49_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "576.8,916.4 300.4,988.3 337,1016.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_51_",
    x: -411.6,
    y: -236.5,
    width: 1833.9,
    height: 1833.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_51_",
    style: {
      overflow: "visible"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M579.1,672.1c-26.9,0-48.5,22.9-48.5,51.3c0,28.2,21.8,51.3,48.5,51.3c26.9,0,48.5-22.9,48.5-51.3 C627.6,694.9,606,672.1,579.1,672.1z M533.1,473.7l7.9,151.4c0.3,7.1,5.8,12.7,12.7,12.7H605c6.6,0,12.2-5.6,12.7-12.7l7.9-151.4 c0.5-7.6-5.3-14-12.7-14h-67.1C538.4,459.7,532.6,466.1,533.1,473.7L533.1,473.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpWarning);
export default __webpack_public_path__ + "static/media/pp_warning.edb92482cc1d57afb83ddd7785beec14.svg";
export { ForwardRef as ReactComponent };